'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = require('../util');

var _constants = require('../constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {
      width: '100%',
      fontSize: 30,
      background: 'transparent',
      font: 'inherit',
      color: 'inherit',
      cursor: 'pointer',
      textAlign: 'center',
      border: [[1, 'solid']],
      padding: [[0, 10]]
    },
    option: {
      color: theme.colorText,
      background: theme.bgCard
    }
  };
};

var LabelDropdown = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(LabelDropdown, _React$Component);

  function LabelDropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LabelDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LabelDropdown.__proto__ || Object.getPrototypeOf(LabelDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelect = function (ev) {
      return _this.props.handleSelect(ev.target.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LabelDropdown, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          labels = _props.labels,
          classes = _props.classes;
      var labelList = Array.isArray(labels) ? labels : [_constants.NO_LABEL];
      return _react2["default"].createElement('select', {
        tabIndex: '1',
        className: classes.root,
        onChange: this.handleSelect
      }, labelList.map(function (label) {
        return _react2["default"].createElement('option', {
          className: classes.option,
          value: label,
          key: label
        }, label);
      }));
    }
  }]);

  return LabelDropdown;
}(_react2["default"].Component), _class2.defaultProps = {
  labels: [_constants.NO_LABEL]
}, _class2.propTypes = {
  labels: _propTypes2["default"].arrayOf(_propTypes2["default"].string)
}, _temp2)) || _class);
exports["default"] = LabelDropdown;